
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 94.2 94.2"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"47.1","cy":"47.1","r":"47.1","fill":"#cad3e0"}}),_c('path',{attrs:{"d":"M88.2 53.5H75.7c-.4 0-.8.3-1 .6l-6.6 13.2-1.1-8.8-2.1 2.1 1.4 10.9c.1.5.4.9.9 1h.2c.4 0 .8-.2 1-.6l8-16h11.8c.6 0 1.2-.5 1.2-1.2s-.6-1.2-1.2-1.2zm-18.7-31c-6-4-15.2-2.9-22.4 3.1-7.3-6-16.4-7.1-22.5-3.1-7.8 5.1-6.7 16.5-6.4 19.3C19.7 57.9 45 73 47 74c1.2-.6 10.2-6 17.9-13.5l-2.2-17.3L56 63.3c-.2.5-.6.8-1.1.8-.5 0-.9-.3-1.1-.8l-3.6-10.7-2.8 2.8c-.1.1-.2.2-.4.3s-.3.1-.4.1H34.2c-.6 0-1.2-.5-1.2-1.2s.5-1.2 1.2-1.2h12l3.8-3.8c.1-.1.3-.2.5-.3h.6c.4.1.7.4.8.8l3.1 9.2 7.2-21.6c.2-.5.7-.8 1.2-.8s1 .5 1 1L67 58.4c4.7-5 8.4-10.7 9-16.6.3-2.9 1.3-14.2-6.5-19.3z","fill":"#fff"}})])
          )
        }
      }
    